<template>
  <div class="fixed top-0 right-0 max-w-full justify-center items-center z-10 mt-4 mr-4" v-if="!$page.props.loading">
    <transition name="fade">
      <div v-if="$page.props.flash.success && show" class="flex items-center justify-center bg-green-500 pl-4 pr-2 rounded-lg py-2">
        <div class="flex items-center text-center mr-2">
          <div class="py-2 text-white text-sm font-medium">{{ $page.props.flash.success }}</div>
        </div>
        <button type="button" class="group p-2" @click="show = false">
          <svg class="block w-3 h-3 fill-current text-green-700 group-hover:text-green-900"
               xmlns="http://www.w3.org/2000/svg" width="235.908" height="235.908"
               viewBox="278.046 126.846 235.908 235.908">
            <path
              d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z"/>
          </svg>
        </button>
      </div>
      <div v-if="$page.props.flash.error && show" class="flex items-center justify-center bg-red-500 pl-4 pr-2 rounded-lg py-2">
        <div class="flex items-center text-center mr-2">
          <div class="py-2 text-white text-sm font-medium">{{ $page.props.flash.error }}</div>
        </div>
        <button type="button" class="group p-2" @click="show = false">
          <svg class="block w-3 h-3 fill-current text-red-700 group-hover:text-red-900"
               xmlns="http://www.w3.org/2000/svg" width="235.908" height="235.908"
               viewBox="278.046 126.846 235.908 235.908">
            <path
              d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z"/>
          </svg>
        </button>
      </div>
      <div v-if="Object.keys($page.props.errors).length > 0 && show" class="flex items-center justify-center bg-red-700 pl-4 pr-2 rounded">
        <div class="flex items-center">
          <div class="py-2 text-white text-sm font-medium">
            <span v-if="Object.keys($page.props.errors).length === 1">There is one form error.</span>
            <span v-else>There are {{ Object.keys($page.props.errors).length }} form errors.</span>
          </div>
        </div>
        <button type="button" class="group p-2" @click="show = false">
          <svg class="block w-2 h-2 text-red-300 fill-current" xmlns="http://www.w3.org/2000/svg"
               width="235.908" height="235.908" viewBox="278.046 126.846 235.908 235.908">
            <path
              d="M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z"/>
          </svg>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        show: true,
        timeout: null
      }
    },
    watch: {
      '$page.props.flash': {
        handler() {
          this.show = true;
          if (this.timeout) {
            clearTimeout(this.timeout);
          }
          this.timeout = setTimeout(() => {
            this.show = false;
          }, 1500);
        },
        deep: true,
      },
    }
  }
</script>
